import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RoutingService {

  constructor(    
    private router: Router
  ) { }

  public goHome(): void {
    this.goto('/');
  }

  public goDash(): void {
    this.goto('/');
  }

  public goProfile(): void {
    this.goto('/users/profile');
  }

  public goForms(): void {
    this.goto('/forms');
  }

  public goCaptures(): void {
    this.goto('/forms/captures/pendings');
  }

  public goSopDocs(): void {
    this.goto('/forms/sop');
  }

  public go(path:string):void {
    this.goto(path);
  }

  public goLogin():void {
    this.goto('/auth/login')
  }

  public goRegister():void {
    this.goto('/sessions/register')
  }

  private goto(to: string, skip = false): void {
    this.router.navigateByUrl(to, { skipLocationChange: skip });
  }
}
